// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js","976":"c16184b3"}[chunkId] + "-" + {"678":"d09cd03879401cdfee92","883":"8d2a511cac3d2b95e8bc","976":"793d66382c51926d211d"}[chunkId] + ".js";
};